import React from 'react';
import {
    usePortfolio,
    useSnaptrade
} from '../../logic/imports';
import * as Common from '../app/CommonComps';

export const AccountPanel: React.FC = () => {
    const { balances } = usePortfolio();
    const { activeAccountId, isActivating } = useSnaptrade();

    // If switching accounts, show loading state with animated ellipsis
    if (isActivating) {
        return (
            <div className="panel">
                <div className="panel-header">Active Account</div>
                <div style={{ 
                    padding: '20px',
                    fontSize: '1rem',
                    textAlign: 'center', 
                    color: '#888' 
                }}>
                    <span>Switching accounts, this may take a while</span>
                    <span className="animated-ellipsis"></span>
                    <style>{`
                        @keyframes ellipsis {
                            0% { content: ""; }
                            20% { content: "."; }
                            40% { content: ".."; }
                            60% { content: "..."; }
                            80% { content: "...."; }
                            100% { content: "....."; }
                        }
                        .animated-ellipsis::after {
                            content: "...";
                            animation: ellipsis 1.5s infinite;
                            display: inline-block;
                            width: 1.5em;
                            text-align: left;
                        }
                    `}</style>
                </div>
            </div>
        );
    }

    // If no account is connected, show message
    if (!activeAccountId) {
        return (
            <div className="panel">
                <div className="panel-header">Active Account</div>
                <div style={{ 
                    padding: '20px', 
                    fontSize: '1rem',
                    textAlign: 'center', 
                    color: '#888' 
                }}>
                    No Active Account
                </div>
            </div>
        );
    }

    // If balances haven't loaded yet, show loading state
    if (!balances) {
        return (
            <div className="panel">
                <div className="panel-header">Active Account</div>
                <div>Loading portfolio data...</div>
            </div>
        );
    }

    // Display account values
    const accountVal = balances.accountValue;
    const cashSettled = balances.cashSettled;

    return (
        <div className="panel">
            <div className="panel-header">Active Account</div>
            
            <Common.KeyValueDisplay
                name="Account Value"
                value={accountVal}
                numericValueFormat="dollars"
            />

            <Common.KeyValueDisplay
                name="Buying Power"
                value={cashSettled}
                numericValueFormat="dollars"
            />

            {/* Equity breakdown chart - commented out until balances includes equity breakdown
            <Common.SegmentedBar
                segments={[
                    {
                        value: cashSettled,
                        label: 'Settled',
                        color: '#4caf50'
                    },
                    {
                        value: accountVal - cashSettled,
                        label: 'Invested',
                        color: '#2196f3'
                    }
                ]}
                maxWidth={400}
                showPercentages={true}
            />
            */}

        </div>
    );
}